// Flag to prevent showing modal multiple times
let updateModalShown = false

// Function to show modal only once
function showUpdateModalOnce () {
  if (updateModalShown) {
    return
  }

  updateModalShown = true

  if (window.showUpdateModal) {
    window.showUpdateModal()
  } else {
    // Fallback: auto-reload if modal not ready
    console.warn('This page has been updated. Please refresh to see the latest version.')
    window.location.reload(true)
  }
}

// Initialize chunk error handlers
export function initChunkErrorHandlers (router) {
  // Global error handler for dynamic imports
  router.onError(error => {
    const chunkFailedMessage = /Loading chunk .+ failed/
    const isChunkLoadError = error.name === 'ChunkLoadError' ||
                            (error.message && chunkFailedMessage.test(error.message))

    if (isChunkLoadError) {
      console.error('Chunk load failed:', error)
      showUpdateModalOnce()
    }
  })

  // Fallback handler for script and CSS loading errors (MIME type issues)
  window.addEventListener('error', (event) => {
    if (event.target && (event.target.tagName === 'SCRIPT' || event.target.tagName === 'LINK')) {
      const src = event.target.src || event.target.href
      if (src && (src.includes('/js/chunk-') || src.includes('/css/chunk-'))) {
        console.error('Chunk resource failed to load:', src)
        showUpdateModalOnce()
      }
    }
    // Check for CSS and JS MIME type errors in error messages
    if (event.message && event.message.includes('MIME type') && event.message.includes('text/html') &&
        (event.message.includes('refused to apply style') || event.message.includes('refused to execute script'))) {
      console.warn('MIME type error detected - likely due to outdated chunks')
      showUpdateModalOnce()
    }
  }, true)
}
